import type { ReactElement } from 'react';

import Layout from '@/components/Landing/Layout';
import ClientPage from '@/components/OurSuccessStories/ClientPage';
import Text from '@/components/Text';

const Junction = () => {
  return (
    <ClientPage
      companyName="Junction"
      clientId="junction"
      description={
        <>
          <Text variant="body" className="text-jb-neutral-100">
            Educational Platform designed to revolutionize the learning
            experience. With a focus on personalized and interactive education,
            Junction seamlessly connects students, educators, and resources in a
            dynamic virtual environment.
          </Text>
          <Text variant="body" className="text-jb-neutral-100">
            The platform empowers users to create tailored learning paths,
            collaborate. Junction provides a comprehensive digital ecosystem
            that enhances engagement, motivation, and knowledge retention.
          </Text>
        </>
      }
      topImage="/clients/junction/content.webm"
      bottomImage="/clients/junction/instructro-tool.webm"
      scope={
        <>
          <Text variant="body" className="text-jb-neutral-400">
            Junction is an educational platform designed to revolutionize the
            learning experience by providing a personalized, interactive, and
            connected digital environment.
          </Text>
          <Text variant="body" className="text-jb-neutral-400">
            It brings together students, educators, and resources, offering
            tools for tailored learning paths, collaboration, and progress
            tracking within a unified ecosystem.
          </Text>
        </>
      }
      industry="Education"
      country="New York, NY, USA"
    />
  );
};

Junction.getLayout = (page: ReactElement) => (
  <Layout theme="dark">{page}</Layout>
);

export default Junction;
